import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

import { makeBusyFunction } from "lib/@components/busy/make-busy-function"

const IMPORT_LEGACY_DRAFT_CUSTOM_SCHEDULES = gql`
    mutation ImportLegacyDraftCustomSchedules($subscriptionId: Int!, $selectedIds: [Int!]!) {
        importLegacyDraftCustomSchedules(subscriptionId: $subscriptionId, selectedIds: $selectedIds) {
            imported
            skipped
            alreadyRunning
        }
    }
`

export const importLegacyDraftCustomSchedules = makeBusyFunction(
    api(function importLegacyDraftCustomSchedules(subscriptionId, selectedIds) {
        return mutate(
            IMPORT_LEGACY_DRAFT_CUSTOM_SCHEDULES,
            { subscriptionId, selectedIds },
            { returns: "importLegacyDraftCustomSchedules" }
        )
    }),
    "Import Legacy Draft Custom Schedules"
)
